


import { Routes, RouterModule } from '@angular/router';
import { ExecutionErrorComponent } from './executionerror.component';

const routes: Routes = [
    {
        path: '',
        component: ExecutionErrorComponent
    },
];

export const ExecutionErrorRoutes = RouterModule.forChild(routes);
